<ng-container class="fs-unmask" *ngIf="!(dynamicPageService.hideValidation$ | async)">
  <ng-container *ngIf="!displayFormat || displayFormat === 'line'">
    <ng-container *ngFor="let validationName of failedValidations">
      <span *ngIf="getDetailedValidationMessage(validationName)" id="error-{{ fieldId }}" class="bl-error-msg bl-margin-top--4" role="alert">
        {{ getDetailedValidationMessage(validationName) }}
      </span>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="displayFormat === 'alert'">
    <ea-alert
      alertId="alert-{{ validationName }}"
      *ngFor="let validationName of failedValidations"
      alertStatus="error"
      class="bl-display--block bl-margin-top--16 bl-margin-bottom--16"
      [message]="'' + getValidationMessage(validationName)"
    >
    </ea-alert>
  </ng-container>
</ng-container>
